export const EMBED_TWITTER_CONFIG = {
    name        : 'Twitter',
    icon        : 'i5-twitter',
    iconSvg     : 'isvg-twitter',
    description : 'Embeded Twitter',
    embedCode   : '',
    projectIcon : 'twitterX',                   // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['x.com', 'twitframe.com']    // required for embedCode content search for autodetect EmbedType
}